import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, Button, Collapse, CardBody } from 'reactstrap';
import BoolInput from '../../../../../misc/BoolInput';
import EnumInput from '../../../../../misc/EnumInput';
import { CoreScheduleSyncGoogleConfiguration } from '../../../../../../models/CoreScheduleSyncGoogleModels';
import { eventVisibilityOptions, resourceModeOptions } from './ScheduleSyncGoogleTypes';


interface ScheduleSyncGoogleConfigurationProps {
    disabled: boolean
    configuration: CoreScheduleSyncGoogleConfiguration
    updatePart: (part: Partial<CoreScheduleSyncGoogleConfiguration>) => void
}


const ScheduleSyncGoogleConfiguration = (props: ScheduleSyncGoogleConfigurationProps) => {
    const { t } = useTranslation(['common', 'configuration']);
    const [open, setOpen] = useState<boolean>(true);

    return (
        <Card className="edit_module">
            <CardHeader tag="h2">
                <Button outline color="secondary" style={{ width: '37px', float: 'right' }} onClick={() => setOpen(!open)}>{open ? '-' : '+'}</Button>
                {t('modules.ScheduleSyncGoogle.title', { ns: 'common' })}
            </CardHeader>
            <Collapse isOpen={open}>
                <CardBody>
                    <div style={{ margin: '1rem 0' }}>
                        <EnumInput
                            title={t('googleCalendarConfiguration.resourceNode.title', { ns: 'configuration' })}
                            name='resourceMode'
                            value={props.configuration.resourceMode}
                            options={resourceModeOptions.map(key => ({
                                value: key,
                                text: t(`googleCalendarConfiguration.resourceNode.options.${key}`, { ns: 'configuration' })
                            }))}
                            onChange={(name, value) => props.updatePart({ [name]: value })}
                            disabled={props.disabled}
                        />
                        <BoolInput
                            title={t('googleCalendarConfiguration.includeMeetLink.title', { ns: 'configuration' })}
                            name='includeMeetLink'
                            value={props.configuration.includeMeetLink}
                            updateValue={(name, value) => props.updatePart({ [name]: value })}
                            disabled={props.disabled}
                        />
                        <EnumInput
                            title={t('googleCalendarConfiguration.eventVisibility.title', { ns: 'configuration' })}
                            name='eventVisibility'
                            value={props.configuration.eventVisibility}
                            options={eventVisibilityOptions.map(key => ({
                                value: key,
                                text: t(`googleCalendarConfiguration.eventVisibility.options.${key}`, { ns: 'configuration' })
                            }))}
                            onChange={(name, value) => props.updatePart({ [name]: value })}
                            disabled={props.disabled}
                        />
                    </div>
                </CardBody>
            </Collapse>
        </Card>)
}

export default ScheduleSyncGoogleConfiguration;
